module.exports = __webpack_public_path__ + "3de212703d1194fff81f905d301c3ca6.png";